import $ from 'jquery'
import config from '../../config'

class UtilsService {

    constructor() {
        this.baseUrl = config.apiUrl;
    }

    sendPlainEmail(from, to, replyTo, subject, message) {
        return $.ajax({
            method: "POST",
            data: {
                from: from,
                to: to,
                replyTo: replyTo,
                subject: subject +" - via troistudio.com",
                message: message,
                contentType: "plain"
            },
            url: this.baseUrl+"/email/send"
        });
    }

}

export default UtilsService;



// WEBPACK FOOTER //
// ./src/system/services/UtilsService.js